export enum RequestStatus {
  NOTREQUESTED = "NOTREQUESTED",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  LOADING = "LOADING",
}
